import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Design of the filters",
  layout: {
    type: "customCase040105",
    options: {
      views: {
        speaker: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide05-speaker.svg`,
        },
        woofer: {
          gallery: [
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide05-woofer01.svg`,
              description: "1. Woofer filter",
            },
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide05-woofer02.svg`,
              description: "2. Filtered woofer",
            },
          ],
        },
        tweeter: {
          gallery: [
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide05-tweeter01.svg`,
              description: "1. Tweeter filter",
            },
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide05-tweeter02.svg`,
              description: "2. Filtered tweeter",
            },
          ],
        },
        capacity: {
          eq1ImageUrl: `${config.ASSETS_URL}/04/case-01/slide05-capacity-eq01.svg`,
          eq2ImageUrl: `${config.ASSETS_URL}/04/case-01/slide05-capacity-eq02.svg`,
          task: {
            correctAnswer: 3,
          },
        },
      },
    },
  },
};

export default principle;
